import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ScheduleService } from '../schedule.service';
import { ScheduleJob } from '../schedulejob';
import { empty, Observable } from 'rxjs';
import { tap, map, switchMap, debounceTime } from 'rxjs/operators';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RatingPhotosDialogComponent } from '../rating-photos/ratingphotos.component';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { RaterformComponent, RaterformSelectorComponent } from '../../raterform/raterform/raterform.component';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { EditJobDialogComponent } from '../../location/location.component';
import { LoggingService } from '../../utils/logging.service';
import { io } from 'socket.io-client';
import { AuthService } from '../../auth.service';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { ViewJobLocationsComponent } from '../../location/location.component';
import { LocationService } from '../../location/location.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { EditSubdivisionDialogComponent } from '../../subdivisions/subdivisions/subdivisions.component';
import { SubdivisionService } from '../../subdivisions/subdivision.service';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';




@Component({
  selector: 'app-failreason',
  templateUrl: './failreason.component.html',
  styleUrls: ['./schedule.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FailReasonComponent implements OnInit {


  camData: any;
  employee$: Observable<any[]>;
  failreasons : any[] = [];
  employee_id : number;
  selectedReasons;
  responsibleTrades :any[] = [];

  constructor( public dialogRef: MatDialogRef<FailReasonComponent>, public service: LocationService, @Inject(MAT_DIALOG_DATA) public data: any, public scheduleService: ScheduleService, private messager: MessagerComponent) { }



  ngOnInit(): void {

    this.failreasons = this.data.failreasons;
    console.log(this.failreasons);
    this.selectedReasons = [];
    console.log(typeof this.selectedReasons);


    this.scheduleService.getFailJobReasons(this.data.job.job_id).subscribe(
      res => {
        if(res.Error){
          this.selectedReasons = [];
        }else {
          this.selectedReasons = res;
        }
        console.log(this.selectedReasons);
      },err => {
        this.selectedReasons = [];
        this.messager.openSnackBar('Status not updated!', '', 'warningAlert');
      }
    )

    this.scheduleService.getResponsibleTrades(this.data.job.form_id).subscribe(
      res => {
        this.responsibleTrades = res;
        console.log(this.responsibleTrades);
      },err => {
        this.responsibleTrades.push("No Trades Selected");
        this.messager.openSnackBar('No responsible trades selected.', '', 'warningAlert');
      });





  }


  addFailReason(fr): void {

      console.log(fr);

      //check if already in array
      let index = this.selectedReasons.indexOf(fr);
      if (index > -1) {
        this.selectedReasons.splice(index, 1);
      } else {
        this.selectedReasons.push(fr);
      }
      console.log(this.selectedReasons);

  }

  updateFailReason(): void {

    console.log(this.selectedReasons);
    //item.conf_status = status;
    this.data.job.failreason = this.selectedReasons;
    this.scheduleService.setFailReason(this.data.job.job_id, this.data.job).subscribe(
      res => {
        this.messager.openSnackBar('Status updated!', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Status not updated!', '', 'warningAlert');
      });

      this.dialogRef.close();

  }



}
